import { T } from "../constants";

export default function IngredientRow({ ing, isLast }) {
  return (
    <div style={{
      display: "flex", justifyContent: "space-between",
      alignItems: "flex-start", gap: "1rem", padding: "8px 0",
      borderBottom: isLast ? "none" : `0.5px solid ${T.linen3}`,
    }}>
      <div>
        <div style={{ fontSize: "0.9rem", color: T.bark, fontWeight: 500 }}>
          {ing.name}
        </div>
        {ing.notes && (
          <div style={{ fontSize: "0.75rem", color: T.muted, fontStyle: "italic", marginTop: "1px" }}>
            {ing.notes}
          </div>
        )}
      </div>
      <div style={{ fontSize: "0.82rem", color: T.muted, flexShrink: 0, textAlign: "right" }}>
        {ing.amount}
      </div>
    </div>
  );
}
